<form [formGroup]="telefonosFormGroup">
  <div class="row" formArrayName="telefonos" *ngFor="let telFG of telefonos().controls; index as i">
    <div class="row" [formGroupName]="i">
      <mat-form-field class=" col-3">
        <mat-label>Prefijo:</mat-label>
        <mat-select formControlName="pais_codigo" required
          (selectionChange)="onPaisSelected($event.value, telFG); paisSelected[i] = $event.value"
          [disabled]="i==0 && (this.defaultPais != null)">
          <mat-select-trigger>
            <ng-container *ngIf="paisSelected[i]">
              <div class [ngClass]="'imgBandera flag flag-' + paisSelected[i].codigo"></div>
              {{paisSelected[i].codigo_telefonico}}
            </ng-container>
          </mat-select-trigger>
          <mat-option *ngFor="let pais of paises" [value]="pais">
            <ng-container *ngIf="pais.bandera">
              <div [ngClass]="'imgBandera flag flag-' + pais.codigo"></div>
            </ng-container>
            {{pais.nombre}} ({{pais.codigo_telefonico}})
          </mat-option>
        </mat-select>
        <mat-error *ngIf="telFG.get('pais_codigo')?.hasError('required')">
          Debe ingresar país
        </mat-error>
      </mat-form-field>
      <mat-form-field class="col-8">
        <input matInput placeholder="Número de teléfono:" formControlName="telefono" required [maxlength]="15">
        <mat-error *ngIf="telFG.get('telefono')?.hasError('required')">
          Debe ingresar el número de teléfono
        </mat-error>
        <mat-error *ngIf="telFG.get('telefono')?.hasError('minlength')">
          El número de teléfono debe tener como mínimo 8 dígitos
        </mat-error>
        <mat-error *ngIf="telFG.get('telefono')?.hasError('maxlength')">
          El número de teléfono debe tener como maximo 9 dígitos
        </mat-error>
      </mat-form-field>
      <div class="col-1">
        <button type="button" class="float-right" mat-icon-button (click)="eliminarTelefono(i)" color="warn"
          [disabled]="i==0" matTooltip="Eliminar número de contacto">
          <mat-icon>
            <fa-icon icon="minus"></fa-icon>
          </mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <button type="button" class="buttonAdd" (click)="agregarTelefono()" mat-icon-button color="primary"
      matTooltip="Agregar nuevo teléfono de contacto">
      <mat-icon>
        <fa-icon icon="plus"></fa-icon>
      </mat-icon>
    </button>
  </div>
</form>